:host{position:absolute;top:50%;left:50%}
/*# sourceMappingURL=calculator.component-SBCWW7MM.css.map */
